import { useState } from 'react';

export default function Hero() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="relative bg-white">
      {/* Navigation */}
      <nav className="relative z-50 px-6 py-6">
        <div className="flex items-center justify-between w-full">
          {/* Left Navigation Items */}
          <div className="flex items-center space-x-8">
            <img 
              src="https://static.readdy.ai/image/18c6998c39bb0c6800adc881f1fbc8c0/b69dc01a38e55ca7dddfd05b194eb92a.jpeg" 
              alt="BigBen PLLC" 
              className="h-8 w-auto cursor-pointer"
            />
            <a href="#services" className="text-gray-800 hover:text-blue-600 transition-colors cursor-pointer font-semibold">Services</a>
            <a href="#settlement-tracker" className="text-gray-800 hover:text-blue-600 transition-colors cursor-pointer font-semibold">Results</a>
          </div>
          
          {/* Right Navigation Items */}
          <div className="flex items-center space-x-8">
            <a href="#about" className="text-gray-800 hover:text-blue-600 transition-colors cursor-pointer font-semibold">About</a>
            <a href="#contact" className="bg-cyan-500 text-white px-6 py-2 rounded-full hover:bg-cyan-600 transition-colors cursor-pointer whitespace-nowrap font-semibold">Free Consultation</a>
            <a href="tel:5617652540" className="text-gray-800 hover:text-blue-600 transition-colors cursor-pointer font-semibold">(561) 765-2540</a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-800"
          >
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-200 px-6 py-4 shadow-lg">
            <div className="flex flex-col space-y-4">
              <a href="#services" className="text-gray-800 hover:text-blue-600 transition-colors cursor-pointer font-semibold">Services</a>
              <a href="#settlement-tracker" className="text-gray-800 hover:text-blue-600 transition-colors cursor-pointer font-semibold">Results</a>
              <a href="#about" className="text-gray-800 hover:text-blue-600 transition-colors cursor-pointer font-semibold">About</a>
              <a href="#contact" className="bg-cyan-500 text-white px-6 py-2 rounded-full hover:bg-cyan-600 transition-colors cursor-pointer text-center whitespace-nowrap font-semibold">Free Consultation</a>
              <a href="tel:5617652540" className="text-gray-800 hover:text-blue-600 transition-colors cursor-pointer font-semibold text-center">(561) 765-2540</a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 px-6 py-8">
        <div className="max-w-4xl mx-auto text-center">
          {/* Bigger Logo */}
          <div className="mb-8">
            <img 
              src="https://static.readdy.ai/image/18c6998c39bb0c6800adc881f1fbc8c0/b69dc01a38e55ca7dddfd05b194eb92a.jpeg" 
              alt="BigBen PLLC Injury Law" 
              className="h-48 w-auto mx-auto"
            />
          </div>
          
          <div className="text-gray-800">
            <h1 className="text-2xl lg:text-3xl font-bold mb-6 leading-tight">
              Justice Starts Here
            </h1>
            <p className="text-xl mb-8 text-gray-600 leading-relaxed max-w-3xl mx-auto">
              You've been through enough. We'll fight to secure the compensation and closure you need to move forward.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-cyan-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-cyan-600 transition-colors cursor-pointer whitespace-nowrap">
                Get Free Case Review
              </button>
              <button className="border-2 border-gray-800 text-gray-800 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-800 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Call (561) 765-2540
              </button>
            </div>
            <div className="mt-8 flex items-center justify-center space-x-6 text-sm text-gray-600">
              <div className="flex items-center">
                <i className="ri-check-line text-cyan-500 mr-2"></i>
                No Fee Unless We Win
              </div>
              <div className="flex items-center">
                <i className="ri-check-line text-cyan-500 mr-2"></i>
                Free Consultation
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
